<div class="header">

  <div class="header">
    <div class="header-top">

      <button class="menu-button">

        <span class="icon-align-center_" *ngIf="state == 'initial'" (click)="showMenu()">
          <img src="../../../assets/icons/text-align-justify.svg" class="icon-menu">
        </span>
        <span class="icon-close_" *ngIf="state == 'expanded'" (click)="showMenu()">
           <img src="../../../assets/icons/cross.svg" class="icon-menu">
        </span>
      </button>

      <img src="../../../assets/logo_small.png" class="logo" routerLink="/main" routerLinkActive="active" alt="varenka_logo"
           ariaCurrentWhenActive="page"/>

      <menu-panel class="menu-panel"></menu-panel>
    </div>

    <div [@expandedPanel]="!menuActive ? state : ''" [ngClass]="menuActive ?'header-menu':  'hidden-menu' ">
      <div class="menu-item" (click)="navigate('/books')" routerLinkActive="active" ariaCurrentWhenActive="page" id="booksMenuItem">Книги</div>
<!--     <div class="menu-item" (click)="navigate('/arts-play')" routerLinkActive="active" ariaCurrentWhenActive="page" id="artsMenuItem">Art&Play</div>-->
      <div class="menu-item" *ngIf="libraryOn " (click)="navigate('/library')" routerLinkActive="active" ariaCurrentWhenActive="page">Библиотека</div>
      <div class="menu-item" (click)="navigate('/foreign')" routerLinkActive="active" ariaCurrentWhenActive="page" is="foreignMenuItem">Foreign</div>
      <div class="menu-item" (click)="navigate('/contacts')" routerLinkActive="active" ariaCurrentWhenActive="page">Контакты </div>
      <div class="menu-item" (click)="navigate('/news')" routerLinkActive="active" ariaCurrentWhenActive="page">Новости</div>
      <div class="menu-item" *ngIf="franchiseOn " (click)="navigate('/franchise')" routerLinkActive="active" ariaCurrentWhenActive="page">Франшиза</div>

    </div>


  </div>

</div>

